import { GoodsList } from 'components/goods/GoodsList/GoodsList'
import { SELLER_SECTION_WIDTH } from 'components/sellers/SellerWrapper/SellerWrapper'
import { useParams } from 'react-router-dom'

export const SellerGoods: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <GoodsList sellerId={id as string} tableWidth={SELLER_SECTION_WIDTH} />
}
